import Config from './Config';
import Tile from './Tile';
import { randomInt } from '../../functions';

export default class VisualMemoryEngine {
    tiles: Tile[];
    config: Config;

    constructor() {
        this.config = new Config();
        this.tiles = [];
    }

    getTypedTiles(count: number): number[] {
        const maxNum = (this.config.width * this.config.height) - 1;
        const tilesNums: number[] = [];
        while (tilesNums.length < count) {
            const randInt = randomInt(0, maxNum);
            if (tilesNums.indexOf(randInt) === -1) {
                tilesNums.push(randInt);
            }
        }
        return tilesNums;
    }

    initGame() {
        const typedTilesCount = this.config.level + 2;
        const randTiles = this.getTypedTiles(typedTilesCount);
        const len = this.config.width * this.config.height;
        this.config.memoryCount = typedTilesCount;
        this.tiles = [];
        if (typedTilesCount/len > 0.5) {
            this.config.width++;
            this.config.height++;
        }
        console.log(this.config);
        let item = 0;
        for (let i = 0; i < this.config.width; i++) {
            for (let j = 0; j < this.config.height; j++) {
                this.tiles.push(new Tile(true, randTiles.indexOf(item) >= 0));
                item++;
            }
        }
    }

}